import { FixedAccordion } from "@shared/ui/fixed-accordion";
import { CheckIcon } from "@shared/ui/Icon/ui/history/check-icon";
import classes from "./report-vin-options.module.scss";

export const ReportVinOptions = () => {
    return (
        <div className={classes["vin-options"]}>
            <div className={classes["vin-options__desc"]}>
                Опции, установленные на этом автомобиле. Информация по VIN.
            </div>

            <FixedAccordion
                title={
                    <div className={classes["vin-options__title"]}>
                        Мультимедиа
                        <div className={classes["vin-options__count"]}>1</div>
                    </div>
                }
                content={
                    <ul className={classes["vin-options__list"]}>
                        <li className={classes["vin-options__item"]}>
                            <CheckIcon className={classes["vin-options__item--icon"]} />
                            Аудиосистема
                        </li>
                    </ul>
                }
            />
        </div>
    );
};